<div class="flex items-center justify-center dialog-header ">
    Add Contact in Group

    <div class="absolute right-2 flex gap-0 items-center">

        <p-button 
        [disabled]="btnLoading"
        [loading]="btnLoading"
        (click)="onSubmit()" class="outline-none p-5" severity="danger">
            <i class="pi pi-save mr-2"></i> Save

        </p-button>

        <button (click)="handleCloseDialog()" class="outline-none pl-1 pr-5">
            <i class="pi pi-times"></i>
        </button>
    </div>


</div>

<div class="dialog-content">
    <p-tabs [(value)]="activeTabIndex" (valueChange)="onTabChange($event)">
        <p-tablist>
            <p-tab [value]="0">Leads</p-tab>
            <p-tab [value]="1">Contacts</p-tab>
        </p-tablist>
        <p-tabpanels>
            <p-tabpanel [value]="0">
                <p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
                    (onLazyLoad)="loadData($event)" [loading]="loading" [(selection)]="selectedProducts"
                    [style]="{'min-height': '50vh'}" [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined"
                    [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 4rem; border-top-left-radius: 10px;"><p-tableHeaderCheckbox /></th>
                            <th *ngFor="let col of displayedColumns">
                                {{ col.header }}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-customer let-i="rowIndex" let-rowData>
                        <tr [ngClass]="{'disabled-row': isLeadDisabled(rowData)}">
                            <td>
                                <p-tableCheckbox [value]="customer" [disabled]="isLeadDisabled(rowData)" />
                            </td>
                            <td *ngFor="let col of displayedColumns">
                                <ng-container [ngSwitch]="col.type">

                                    <ng-container *ngSwitchCase="'contact_name'">
                                        {{ getFullName(rowData) }}
                                    </ng-container>

                                    <!-- Default Case (Normal Field) -->
                                    <ng-container *ngSwitchDefault>
                                        {{ rowData[col.field] }}
                                    </ng-container>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="loading">
                        <tr>
                            <td colspan="5" class="text-center">
                                <p-progressSpinner></p-progressSpinner>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="displayedColumns.length + 1" class="no-data-record-found">
                                <p>No records found</p>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-tabpanel>
            
            <p-tabpanel [value]="1">
                <p-table [value]="dataSource" [paginator]="true" [rows]="rows" [totalRecords]="totalRecords" [lazy]="true"
                    (onLazyLoad)="loadData($event)" [loading]="loading" [(selection)]="selectedProducts"
                    [style]="{'min-height': '50vh'}" [rowsPerPageOptions]="totalRecords > 10 ? [10, 20, 50] : undefined"
                    [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
                    <ng-template pTemplate="header">
                        <tr>
                            <th style="width: 4rem; border-top-left-radius: 10px;"><p-tableHeaderCheckbox /></th>
                            <th *ngFor="let col of contactsDisplayedColumns">
                                {{ col.header }}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-customer let-i="rowIndex" let-rowData>
                        <tr [ngClass]="{'disabled-row': isContactDisabled(rowData)}">
                            <td>
                                <p-tableCheckbox [value]="customer" [disabled]="isContactDisabled(rowData)" />
                            </td>
                            <td *ngFor="let col of contactsDisplayedColumns">
                                <ng-container [ngSwitch]="col.type">

                                    <ng-container *ngSwitchCase="'contact_name'">
                                        {{ getFullName(rowData) }}
                                    </ng-container>

                                    <!-- Default Case (Normal Field) -->
                                    <ng-container *ngSwitchDefault>
                                        {{ rowData[col.field] }}
                                    </ng-container>
                                </ng-container>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="loading">
                        <tr>
                            <td colspan="4" class="text-center">
                                <p-progressSpinner></p-progressSpinner>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td [attr.colspan]="contactsDisplayedColumns.length + 1" class="no-data-record-found">
                                <p>No records found</p>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </p-tabpanel>
        </p-tabpanels>
    </p-tabs>
</div>